// File generated by the DLS Token Service
const DesignTokens = {
    breakpoints: {
        LayoutMediaQueryMedium: 600,
        LayoutMediaQueryLarge: 1024,
        SizeBaseMq6001023: 600,
        SizeBaseMq1024: 1024
    },
    colorBorder: {
        commonPrimary: '#ced7d4',
        commonSecondary: '#b8b8b8',
        ctaSecondaryDefault: '#adbdb9',
        ctaSecondaryHover: '#8ca39d',
        ctaSecondaryPressed: '#748e88',
        ctaSecondaryFocused: '#adbdb9',
        controlUnselected: '#a0a0a0',
        controlSelected: '#02a783',
        controlDisabled: '#adbdb9',
        controlError: '#e16e75',
        formDefault: '#ced7d4',
        formHover: '#adbdb9',
        formFocused: '#02a783',
        formDisabled: '#adbdb9',
        formError: '#e16e75',
        formErrorHover: '#f0373a',
        dataVizComparisonSecondary: '#b8b8b8',
        dataVizComparisonPrimary: '#666eb4',
        dataVizDefault_1: '#666eb4',
        dataVizDefault_2: '#4ca2a8',
        dataVizDefault_3: '#af74b9',
        dataVizDefault_4: '#b49566',
        dataVizDefault_5: '#dd887c',
        dataVizDefault_6: '#e6b056',
        dataVizDefault_7: '#dd7cc2',
        dataVizDefault_8: '#b0cd5d',
        commonFocused: '#2cb0bc',
        commonError: '#ec979b',
        semanticSuccess: '#05322b',
        semanticError: '#e12d39',
        semanticNeutral: '#adbdb9',
        semanticWarning: '#e87516',
        semanticInfo: '#1f6362'
    },
    colorFill: {
        dataVizComparisonSecondary: '#d0d0d0',
        dataVizComparisonPrimary: '#666eb4',
        dataVizDefault_1: '#666eb4',
        semanticErrorHover: '#fdcbd3',
        semanticNeutralPressed: '#8ca39d',
        semanticErrorSelected: '#e12d39',
        dataVizDefault_2: '#4ca2a8',
        dataVizDefault_3: '#af74b9',
        dataVizDefault_4: '#b49566',
        dataVizDefault_5: '#dd887c',
        dataVizDefault_6: '#e6b056',
        dataVizDefault_7: '#dd7cc2',
        dataVizDefault_8: '#b0cd5d',
        controlErrorHover: '#fdcbd3',
        commonPrimary: '#f8faf9',
        commonSecondary: '#ffffff',
        commonBrand: '#05322b',
        commonTertiary: '#ebefee',
        ctaPrimaryDefault: '#147d64',
        ctaPrimaryHover: '#0c6b58',
        ctaPrimaryPressed: '#014d40',
        ctaPrimaryFocused: '#147d64',
        ctaSecondaryDefault: 'rgba(255, 255, 255, 0)',
        ctaSecondaryHover: '#ebefee',
        ctaSecondaryPressed: '#adbdb9',
        ctaSecondaryFocused: 'rgba(255, 255, 255, 0)',
        ctaCriticalDefault: '#e12d39',
        ctaCriticalHover: '#cf2333',
        ctaCriticalPressed: '#c21a2c',
        controlErrorSupplemental: '#e16e75',
        ctaCriticalFocused: '#e12d39',
        ctaDisabled: '#ebefee',
        controlUnselected: 'rgba(255, 255, 255, 0)',
        controlUnselectedSupplemental: '#a0a0a0',
        controlUnselectedHover: '#f3f3f3',
        controlSelected: '#02a783',
        controlDisabled: '#ebefee',
        controlDisabledSupplemental: '#ced7d4',
        controlError: '#feeaee',
        menuUnselected: '#ffffff',
        menuHighlighted: '#ebefee',
        menuSelected: '#c6f7e2',
        menuSelectedSupplemental: '#effcf6',
        formDisabled: '#ebefee',
        formError: '#feeaee',
        avatarPrimary: '#147d64',
        avatarSecondary: '#653cad',
        avatarTertiary: '#ced7d4',
        avatarCircumference: '#02a783',
        commonOverlay: 'rgba(18, 18, 18, 0.8)',
        controlAccent: '#a0a0a0',
        controlSelectedHover: '#147d64',
        controlSliderDisabled: '#ced7d4',
        controlSliderBackground: '#e7e7e7',
        semanticSuccessDefault: '#147d64',
        semanticSuccessSupplemental: '#199473',
        semanticErrorSupplemental: '#cf2333',
        semanticErrorDefault: '#cf2333',
        semanticInfoDefault: '#299ba3',
        semanticInfoSupplemental: '#299ba3',
        semanticInfoHighlight: '#e1f8f9',
        semanticWarningDefault: '#e87516',
        semanticWarningSupplemental: '#e87516',
        ctaSecondaryHoverSupplemental: '#ced7d4',
        semanticErrorHighlight: '#feeaee',
        semanticWarningHover: '#fcf5c1',
        semanticWarningHighlight: '#fefbe6',
        semanticErrorStatusBackground: '#feeaee',
        semanticWarningStatusBackground: '#fefbe6',
        semanticNeutralHover: '#adbdb9',
        semanticNeutralSelected: '#5c7b74',
        semanticNeutralDefault: '#ced7d4',
        semanticAccentDefault: '#5d37a7',
        semanticAccentSupplemental: '#452996',
        semanticAccentHighlight: '#ece7f5',
        ctaPrimaryHoverSupplemental: '#014d40',
        semanticSuccessPressed: '#65d6ad',
        semanticErrorPressed: '#e16e75',
        semanticSuccessHover: '#8eedc7',
        semanticSuccessHighlight: '#effcf6',
        semanticSuccessStatusBackground: '#effcf6',
        semanticNeutralDisabled: '#ebefee',
        semanticNeutralHighlight: '#ebefee',
        semanticNeutralStatusBackground: '#ebefee'
    },
    colorText: {
        ctaPrimary: '#ffffff',
        commonPrimary: '#121212',
        commonSecondary: '#595959',
        commonDisabled: '#adbdb9',
        commonBrand: '#05322b',
        commonInversePrimary: '#ffffff',
        commonInverseSecondary: 'rgba(255, 255, 255, 0.6)',
        linkPrimaryDefault: '#02a783',
        linkSecondaryDefault: '#1a2321',
        linkTertiaryDefault: '#595959',
        linkHover: '#147d64',
        linkPressed: '#014d40',
        linkDisabled: '#d0d0d0',
        linkInverseDefault: '#ffffff',
        linkInverseHover: '#02a783',
        linkInverseDisabled: '#2a2a2a',
        labelDefault: '#595959',
        labelPlaceholder: '#717171',
        labelDisabledDefault: '#adbdb9',
        labelDisabledHighlighted: '#adbdb9',
        labelError: '#e16e75',
        labelCritical: '#c21a2c',
        labelBrand: '#05322b',
        labelSuccess: '#02a783',
        labelWarning: '#e87516',
        ctaDisabled: '#adbdb9',
        ctaSecondary: '#121212'
    },
    fontFamily: {
        headlineXlarge: '"Poppins", sans-serif',
        headlineLarge: '"Poppins", sans-serif',
        headlineMedium: '"Poppins", sans-serif',
        headlineSmall: '"Poppins", sans-serif',
        titleMedium: '"Poppins", sans-serif',
        titleSmall: '"Poppins", sans-serif',
        subtitleLarge: '"Poppins", sans-serif',
        subtitleMedium: '"Poppins", sans-serif',
        subtitleSmall: '"Poppins", sans-serif',
        bodyLarge: '"Noto Sans", sans-serif',
        bodyMedium: '"Noto Sans", sans-serif',
        bodyMediumSemiBold: '"Noto Sans", sans-serif',
        bodySmall: '"Noto Sans", sans-serif',
        bodySmallSemiBold: '"Noto Sans", sans-serif',
        decorativeLarge: '"Poppins", sans-serif',
        decorativeMedium: '"Poppins", sans-serif',
        decorativeSmall: '"Poppins", sans-serif',
        labelMedium: '"Poppins", sans-serif',
        labelSmall: '"Poppins", sans-serif',
        menuLinkMedium: '"Poppins", sans-serif',
        buttonLinkMedium: '"Poppins", sans-serif',
        buttonLinkSmall: '"Poppins", sans-serif',
        avatarLarge: '"Poppins", sans-serif',
        avatarMedium: '"Poppins", sans-serif',
        avatarSmall: '"Poppins", sans-serif',
        iconMedium: '"Material Icons Outlined"',
        iconSmall: '"Material Icons Outlined"',
        titleMediumMobile: '"Poppins", sans-serif',
        titleSmallMobile: '"Poppins", sans-serif'
    },
    fontWeight: {
        headlineXlarge: '600',
        headlineLarge: '600',
        headlineMedium: '600',
        headlineSmall: '600',
        titleMedium: '600',
        titleSmall: '600',
        subtitleLarge: '600',
        subtitleMedium: '600',
        subtitleSmall: '600',
        bodyLarge: '400',
        bodyMedium: '400',
        bodyMediumSemiBold: '600',
        bodySmall: '400',
        bodySmallSemiBold: '600',
        decorativeLarge: '400',
        decorativeMedium: '400',
        decorativeSmall: '400',
        labelMedium: '500',
        labelSmall: '500',
        menuLinkMedium: '500',
        buttonLinkMedium: '600',
        buttonLinkSmall: '600',
        avatarLarge: '600',
        avatarMedium: '600',
        avatarSmall: '600',
        titleMediumMobile: '600',
        titleSmallMobile: '600'
    },
    fontSize: {
        headlineXlarge: '56px',
        headlineLarge: '48px',
        headlineMedium: '40px',
        headlineSmall: '32px',
        titleMedium: '24px',
        titleSmall: '20px',
        subtitleLarge: '18px',
        subtitleMedium: '16px',
        subtitleSmall: '14px',
        bodyLarge: '16px',
        bodyMedium: '14px',
        bodyMediumSemiBold: '14px',
        bodySmall: '12px',
        bodySmallSemiBold: '12px',
        decorativeLarge: '16px',
        decorativeMedium: '14px',
        decorativeSmall: '12px',
        labelMedium: '14px',
        labelSmall: '12px',
        menuLinkMedium: '14px',
        buttonLinkMedium: '14px',
        buttonLinkSmall: '12px',
        avatarLarge: '20px',
        avatarMedium: '14px',
        avatarSmall: '12px',
        iconMedium: '24px',
        iconSmall: '18px',
        titleMediumMobile: '20px',
        titleSmallMobile: '18px'
    },
    fontLineHeight: {
        headlineXlarge: '62px',
        headlineLarge: '58px',
        headlineMedium: '52px',
        headlineSmall: '40px',
        titleMedium: '28px',
        titleSmall: '24px',
        subtitleLarge: '24px',
        subtitleMedium: '22px',
        subtitleSmall: '20px',
        bodyLarge: '22px',
        bodyMedium: '20px',
        bodyMediumSemiBold: '20px',
        bodySmall: '18px',
        bodySmallSemiBold: '18px',
        decorativeLarge: '22px',
        decorativeMedium: '20px',
        decorativeSmall: '18px',
        labelMedium: '20px',
        labelSmall: '18px',
        menuLinkMedium: '20px',
        buttonLinkMedium: '20px',
        buttonLinkSmall: '18px',
        avatarLarge: '28px',
        avatarMedium: '20px',
        avatarSmall: '18px',
        titleSmallMobile: '24px'
    },
    fontLetterSpacing: {
        headlineXlarge: '-1.5px',
        headlineLarge: '-1px',
        headlineMedium: '-1px',
        headlineSmall: '-0.5px',
        titleMedium: '-0.5px',
        titleSmall: '-0.5px',
        subtitleLarge: '-0.25px',
        subtitleMedium: '-0.25px',
        subtitleSmall: '-0.25px',
        bodyLarge: '0px',
        bodyMedium: '0px',
        bodyMediumSemiBold: '0px',
        bodySmall: '0px',
        bodySmallSemiBold: '0px',
        decorativeLarge: '0px',
        decorativeMedium: '0px',
        decorativeSmall: '0px',
        labelMedium: '-0.25px',
        labelSmall: '-0.25px',
        menuLinkMedium: '-0.25px',
        buttonLinkMedium: '0px',
        buttonLinkSmall: '0px',
        avatarLarge: '0px',
        avatarMedium: '0px',
        avatarSmall: '0px',
        titleMediumMobile: '-0.5px',
        titleSmallMobile: '-0.25px'
    },
    effectBorderRadius: { light: '2px', medium: '4px' },
    effectBorderWidth: { regular: '1px', thick: '2px' },
    effectDropShadow: {
        focusPrimary: '0px 0px 0px 2px #8eedc7ff',
        focusError: '0px 0px 0px 2px #fdcbd3ff',
        elevationLow: '0px 2px 6px 0px #00000014',
        elevationMedium: '0px 2px 6px 0px #0000001f',
        elevationHigh: '0px 2px 8px 0px #00000029',
        elevationExtraHigh: '0px 6px 16px 0px #00000033'
    },
    layoutMediaQuery: {},
    layoutGrid: { columnsSmall: 4, columnsMedium: 8, columnsLarge: 12 },
    motionEasing: {
        fast: 'cubic-bezier(0.42,0,0.58,1)',
        normal: 'cubic-bezier(0.42,0,0.58,1)',
        slow: 'cubic-bezier(0.42,0,0.58,1)'
    },
    motionDuration: { slow: '300ms', normal: '200ms', fast: '100ms' },
    spacing: {
        paddingXxsmall: '4px',
        paddingXsmall: '8px',
        paddingSmall: '12px',
        paddingMedium: '20px',
        paddingLarge: '32px',
        paddingXlarge: '52px',
        paddingXxlarge: '84px',
        marginLarge: '32px',
        marginXlarge: '52px',
        marginXxlarge: '84px',
        marginXxsmall: '4px',
        marginXsmall: '8px',
        marginSmall: '12px',
        marginMedium: '20px'
    },
    colors: {
        base: {
            teal_950: '#05322b',
            teal_900: '#014d40',
            teal_800: '#0c6b58',
            teal_700: '#147d64',
            teal_600: '#199473',
            teal_500: '#02a783',
            teal_400: '#3ebd93',
            teal_300: '#65d6ad',
            teal_200: '#8eedc7',
            teal_100: '#c6f7e2',
            teal_050: '#effcf6',
            gray_900: '#121212',
            translucentGray: 'rgba(18, 18, 18, 0.8)',
            gray_800: '#2a2a2a',
            gray_700: '#414141',
            gray_600: '#595959',
            gray_500: '#717171',
            gray_400: '#888888',
            gray_300: '#a0a0a0',
            gray_200: '#b8b8b8',
            gray_100: '#d0d0d0',
            gray_075: '#e7e7e7',
            gray_050: '#f3f3f3',
            gray_025: '#f9f9f9',
            rose_900: '#b30920',
            rose_800: '#c21a2c',
            rose_700: '#cf2333',
            rose_600: '#e12d39',
            rose_500: '#f0373a',
            rose_400: '#eb4b53',
            rose_300: '#e16e75',
            rose_200: '#ec979b',
            rose_100: '#fdcbd3',
            rose_050: '#feeaee',
            gold_900: '#e87516',
            gold_800: '#ed9d22',
            gold_700: '#f0b529',
            gold_600: '#f3cc30',
            gold_500: '#f4dd33',
            gold_400: '#f6e252',
            gold_300: '#f8e771',
            gold_200: '#faee99',
            gold_100: '#fcf5c1',
            gold_050: '#fefbe6',
            cyan_900: '#1f6362',
            cyan_800: '#26868b',
            cyan_700: '#299ba3',
            cyan_600: '#2cb0bc',
            cyan_500: '#2fc0cf',
            cyan_400: '#3ecad4',
            cyan_300: '#5ad3db',
            cyan_200: '#86e1e5',
            cyan_100: '#b5edef',
            cyan_050: '#e1f8f9',
            purple_900: '#341e86',
            purple_800: '#452996',
            purple_700: '#512f9e',
            purple_600: '#5d37a7',
            purple_500: '#653cad',
            purple_400: '#7c58b9',
            purple_300: '#9376c6',
            purple_200: '#b19dd6',
            purple_100: '#d0c4e6',
            purple_050: '#ece7f5',
            white_100: '#ffffff',
            white_060: 'rgba(255, 255, 255, 0.6)',
            dataViz_100: '#666eb4',
            dataViz_200: '#4ca2a8',
            dataViz_300: '#af74b9',
            dataViz_400: '#b49566',
            dataViz_500: '#dd887c',
            dataViz_600: '#e6b056',
            dataViz_700: '#dd7cc2',
            dataViz_800: '#b0cd5d',
            transparent: 'rgba(255, 255, 255, 0)',
            earth_950: '#1a2321',
            earth_900: '#22302d',
            earth_800: '#334541',
            earth_700: '#415853',
            earth_600: '#506c65',
            earth_500: '#5c7b74',
            earth_400: '#748e88',
            earth_300: '#8ca39d',
            earth_200: '#adbdb9',
            earth_100: '#ced7d4',
            earth_050: '#ebefee',
            earth_025: '#f8faf9'
        }
    },
    base: {
        fontFamilyDecorative: '"Poppins", sans-serif',
        fontFamilyBody: '"Noto Sans", sans-serif',
        fontFamilyIcon: '"Material Icons Outlined"',
        fontWeightRegular: '400',
        fontWeightMedium: '500',
        fontWeightSemibold: '600',
        textTransformUppercase: 'uppercase',
        textTransformCapitalize: 'capitalize',
        textTransformLowercase: 'lowercase',
        textDecorationLineThrough: 'line-through',
        textDecorationUnderline: 'underline',
        fontSize_56: '56px',
        fontSize_48: '48px',
        fontSize_40: '40px',
        fontSize_32: '32px',
        fontSize_24: '24px',
        fontSize_20: '20px',
        fontSize_18: '18px',
        fontSize_16: '16px',
        fontSize_14: '14px',
        fontSize_12: '12px',
        fontSize_10: '10px',
        lineHeight_16: '16px',
        lineHeight_62: '62px',
        lineHeight_58: '58px',
        lineHeight_52: '52px',
        lineHeight_40: '40px',
        lineHeight_28: '28px',
        lineHeight_24: '24px',
        lineHeight_22: '22px',
        lineHeight_20: '20px',
        lineHeight_18: '18px',
        letterSpacing_1_5: '-1.5px',
        letterSpacing_1: '-1px',
        letterSpacing_0_5: '-0.5px',
        letterSpacing_0_25: '-0.25px',
        letterSpacing_0: '0px'
    },
    effect: {
        base: {
            borderRadius_8: '8px',
            borderRadius_12: '8px',
            opacity_95: 0.95,
            opacity_90: 0.9,
            opacity_85: 0.85,
            opacity_80: 0.8,
            opacity_70: 0.7,
            opacity_60: 0.6,
            opacity_50: 0.4,
            opacity_40: 0.4,
            opacity_30: 0.3,
            opacity_20: 0.2,
            opacity_10: 0.1,
            dropShadowRose: '0px 0px 0px 2px #fdcbd3ff',
            dropShadowTeal: '0px 0px 0px 2px #8eedc7ff',
            dropShadowSmall: '0px 2px 6px 0px #00000014',
            dropShadowMedium: '0px 2px 6px 0px #0000001f',
            dropShadowLarge: '0px 2px 8px 0px #00000029',
            dropShadowXlarge: '0px 6px 16px 0px #00000033',
            borderWidth_1: '1px',
            borderWidth_2: '2px',
            borderRadius_2: '2px',
            borderRadius_4: '4px',
            transitionDuration_100ms: '100ms',
            transitionDuration_200ms: '200ms',
            transitionDuration_300ms: '300ms',
            transitionTimingEaseInEaseOut: 'cubic-bezier(0.42,0,0.58,1)'
        }
    },
    sizes: {
        base: {
            space_0: '0px',
            space_4: '4px',
            space_8: '8px',
            space_12: '12px',
            space_20: '20px',
            space_32: '32px',
            space_52: '52px',
            space_84: '84px',
            columns_12: 12,
            columns_8: 8,
            columns_4: 4
        }
    },
    space: {},
    shadows: undefined,
    radii: undefined,
    opacity: undefined,
    version: { base: { figma: '1393779951', cli: '0.0.1' } }
};

export { DesignTokens as D };

